import { OrganizationIcon } from "@primer/octicons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAction } from "../api/hooks";
import { ErrorMessage, Page, PageHead } from "../components/common";
import { Button } from "../components/ui/button";
import { Field } from "../components/ui/field";
import { Input } from "../components/ui/input";

/** Mirrors accounts.ValidOrgName (the repo name rules). */
const NAME_RE = /^[a-z0-9][a-z0-9._-]{0,62}$/;

/** /orgs/new: anyone signed in can start an organization and becomes its owner, as on GitHub. */
export function NewOrg() {
  const act = useAction();
  const qc = useQueryClient();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", description: "" });
  const bad = f.name !== "" && !NAME_RE.test(f.name);
  return (
    <Page narrow>
      <PageHead title="Create an organization">Organizations gather people. You become its owner and can add others.</PageHead>
      <form
        className="flex flex-col gap-4"
        onSubmit={(e) => {
          e.preventDefault();
          act.mutate(
            { path: "/v1/orgs", body: { name: f.name, description: f.description.trim() } },
            {
              onSuccess: () => {
                qc.invalidateQueries({ queryKey: ["me"] });
                nav(`/orgs/${encodeURIComponent(f.name)}`);
              },
            },
          );
        }}
      >
        <Field
          label="Organization name"
          required
          invalid={bad}
          hint={bad ? "Lowercase letters, digits, '.', '_' or '-'." : "Shares its namespace with user names."}
        >
          <Input mono autoFocus value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} aria-invalid={bad} required />
        </Field>
        <Field label="Description" hint="Optional.">
          <Input maxLength={500} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
        </Field>
        {act.error ? <ErrorMessage error={act.error} /> : null}
        <div>
          <Button variant="primary" disabled={act.isPending || !f.name || bad}>
            <OrganizationIcon /> {act.isPending ? "Creating…" : "Create organization"}
          </Button>
        </div>
      </form>
    </Page>
  );
}
